export default "__VITE_ASSET__BtXZSEcF__"